import { render, staticRenderFns } from "./schoolForm.vue?vue&type=template&id=56fb6a50&scoped=true"
import script from "./schoolForm.vue?vue&type=script&lang=js"
export * from "./schoolForm.vue?vue&type=script&lang=js"
import style0 from "./schoolForm.vue?vue&type=style&index=0&id=56fb6a50&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56fb6a50",
  null
  
)

export default component.exports